define('lib/view_helpers/base',['require','underscore','moment','jquery','translate','backbone','lib/Podio.Utils','lib/Podio.Routes','lib/Podio.Config','jst!shared/_action_dropdown','jst!shared/_search_input','jst!shared/dropdown/_dropdown','jst!shared/dropdown/_dropdown_item','jst!shared/dropdown/_grouped_dropdown_items'],function(require) {

  var _ = require('underscore');
  var moment = require('moment');
  var $ = require('jquery');
  var t = require('translate');
  var Backbone = require('backbone');
  var podioUtils = require('lib/Podio.Utils');
  var routes = require('lib/Podio.Routes');
  var podioConfig = require('lib/Podio.Config');

  var jstActionDropdown = require('jst!shared/_action_dropdown');
  var jstSearchInput = require('jst!shared/_search_input');
  var jstDropdown = require('jst!shared/dropdown/_dropdown');
  var jstDropdownItem = require('jst!shared/dropdown/_dropdown_item');
  var jstGroupedDropdownItem = require('jst!shared/dropdown/_grouped_dropdown_items');

  var exports = {
    routes : routes,
    registerHelpers: registerHelpers
  };

  function registerHelpers(helpers) {
    _.bindAll(BasicHelpers, 'dynamic_button', 'button');

    _.extend(exports, helpers);
  }

  var BasicHelpers = {

    image_url : function(path) {
      return '{0}/images/{1}'.format(podioConfig.asset_host, path);
    },

    sound_url : function(path) {
      return '{0}/sounds/{1}'.format(podioConfig.asset_host, path);
    },

    image_url_for : function(file, size) {
      return '{0}/{1}'.format(file, size);
    },

    sass_css_url: function (path) {
      if (podioConfig.environment === 'development') {
        return '{0}/stylesheets/compiled/{1}'.format(podioConfig.asset_host, path);
      } else {
        return '{0}/assets{1}/{2}.css'.format(podioConfig.asset_host, podioConfig.jammit_asset_suffix, path);
      }
    },

    default_avatar_url : function(size) {
      return this.image_url('avatar/defaultavatar_{0}.png'.format(size));
    },

    default_org_url : function(size) {
      var sizes = {
        tiny: "16x16",
        small: "32x32",
        medium: "50x50"
      };

      var dimensions = sizes[size] || '32x32';
      return this.image_url('orgs/default_org_logo_{0}.png'.format(dimensions));
    },

    avatar_url_for : function(profile, size) {
      if(profile instanceof Backbone.Model) {
        return profile.get('image') ? this.image_url_for(profile.get('image').thumbnail_link, size) : this.default_avatar_url(size);
      } else if (profile) {
        return profile.image ? this.image_url_for(profile.image.thumbnail_link, size) : this.default_avatar_url(size);
      }
    },

    thumb_for_profile : function(profile, size, options) {
      var hasAvatar = false;

      if((profile instanceof Backbone.Model && profile.get('image')) || profile && profile.image) {
        hasAvatar = true;
      }

      var dimensions = {
        'tiny': { attr: { width: 16, height: 16 }},
        'small': { attr: { width: 32, height: 32 }},
        'default': { attr: { width: 40, height: 40 }},
        'medium': { attr: { width: 80, height: 80 }},
        'large': { attr: { width: 160, height: 160 }}
      }[size];

      return this.content_tag('img', _.extend({
        'src'   : this.avatar_url_for(profile, size),
        'class' : hasAvatar ? null : 'default-avatar'
      }, dimensions, options));
    },

    thumb_for_org: function(organization, size, options) {

      var dimensions = {
        'tiny': { attr: { height: 16 }},
        'small': { attr: { height: 32 }},
        'default': { attr: { height: 40 }},
        'large': { attr: { height: 50 }}
      }[size];

      var url;
      if(organization instanceof Backbone.Model) {
        url = organization.get('image') ? this.image_url_for(organization.get('image').thumbnail_link, size) : this.default_org_url(size);
      } else {
        url = organization.image ? this.image_url_for(organization.image.thumbnail_link, size) : this.default_org_url(size);
      }

      return this.content_tag('img', _.extend({
        'src': url
      }, dimensions, options));
    },

    uploaded_file_is_image: function(file) {
      if (_.isUndefined(file)) {
        return false;
      }

      return !_.isNull(file.thumbnail_link);
    },

    getPresenceState: function(lastSeenOn) {
      var state = {status: 'offline', status_text: ''};

      if (!lastSeenOn) {
        return state;
      }

      var now = moment.utc();
      var then = moment.utc(lastSeenOn);
      var diff = now.diff(then, 'minutes');

      if (diff <= 5) {
        state.status = 'online';
        state.status_text = t('Online #presence');
      } else if (diff <= 30) {
        state.status = 'idle';
        state.status_text = t('Idle #presence');
      } else {
        state.status_text = (t('Last seen: {0} #presence').format(then.fromNow()));
      }

      return state;
    },

    render: function(templateFunc, data) {
      data = _.extend(data || {}, this);
      return templateFunc(data);
    },

    // entries is an array of objects which look like: { iconClass: 'String', label: 'String', href: 'String', linkClass: 'String' }
    // options can be iconClass, label, triggerClass
    renderActionDropdown: function(entries, options) {
      return this.render(jstActionDropdown, { entries: entries || [], options: options || {} });
    },

    searchInput: function(inputClass, inputPlaceholderText, options) {
      return this.render(jstSearchInput, {
        inputClass: inputClass ,
        inputPlaceholderText: inputPlaceholderText,
        options: options || {}
      });
    },

    content_tag : function(tagName, options) {
      // Use jQuery to create document fragments
      var elmDiv = $('<div>');
      $( '<{0}>'.format(tagName), options).appendTo(elmDiv);

      return elmDiv.html();
    },

    link_to: function(url, content, options) {
      options = options || {};

      return this.content_tag('a', _.extend({
        href : url,
        html: options.raw ? content : _.escape(content)
      }, options));

    },

    dynamic_link_to: function(url, content, options) {
      options = options || {};

      _.defaults(options, {
        'data-link-type': 'no-reload',
        'data-render-as': 'overlay'
      });

      return this.link_to(url, content, options);
    },

    new_lines_to_br: function(content) {
      var regex = /\n/gi;
      return content.replace(regex, '<br>');
    },

    auto_link: function(content, options) {
      options = options || {};

      // from https://github.com/bryanwoods/autolink-js
      var regex = /(^|\s)((?:https?|ftp):\/\/[\-A-Z0-9+\u0026@#\/%?=()~_|!:,.;]*[\-A-Z0-9+\u0026@#\/%=~()_|])/gi;

      _.defaults(options, {
        escape: true
      });

      if (options.escape) {
        content = _.escape(content);
      }

      return content.replace(regex, "$1<a href='$2'>$2</a>");
    },

    link_or_disabled: function(allow_link, url, content, options) {
      if (allow_link) {
        options['title'] = '';
        return this.link_to(url, content, options);
      }
      else {
        var classList = options['class'] ? options['class'].split(' ') : [];
        classList.push('disabled');
        classList.push('tooltip');
        delete options['class'];
        return this.content_tag('span', _.extend({
          html: options.raw ? content : _.escape(content),
          title: t('You are not an admin of the space. #lefthand-nav'),
          'class': _.uniq(classList).join(' ')
        }, options));
      }
    },

    dynamic_button: function(text, link, options) {
      options = options || {};

      _.defaults(options, {
        'data-link-type': 'no-reload',
        'data-render-as': 'overlay'
      });

      return this.button(text, link, options);
    },

    button: function(text, link, options) {
      options = options || {};

      options['color'] = options['color'] || 'primary';
      options['class'] = 'button-new {0} {1}'.format( options['class'] || '', options['color'] );

      if (options['icon']) {

        var iconHtml = '<div class="left {0}"></div>';
        var textHtml = '<div class="text">{1}</div>';
        var buttonHtml = iconHtml + textHtml;

        if( options['icon-align'] == 'right' ) {
          buttonHtml = textHtml + iconHtml;
          options['icon-align'] = null;
          options['wrapperClass'] = 'icon-align-right';
        }

        var properties = _.extend({
          'class' : 'button-with-icon {0}'.format( options['wrapperClass'] ? options['wrapperClass'] : ''),
          'html'  :  buttonHtml.format(options['icon'], _.escape(text))
        }, options.properties || {});

        text = this.content_tag('div', properties);
        options.raw = true;

        options['icon'] = null;
      }

      if(options['element'] == 'button') {
        options['element'] = null;
        options['text'] = text;
        options['raw'] = null;

        _.extend(options, options.properties);
        options['properties'] = null;

        return this.content_tag('button', options);
      } else {
        return this.link_to(link, text, options);
      }
    },

    /* expected data schemes:
       for grouped items: [{ label: 'Group label', items: [ ... ] }, ...], see below for items,
       for ungrouped items: [{ id: 'String', label: 'Item label', iconClass: '' }], id and iconClass are optional

       options:
        - skin: CSS skin applied, defaults to bubble
        - grouped: bool, defaults to false
        - classNames: CSS classes applied
        - toggleText: custom label for the toggler, optional
     */
    dropdown: function(id, data, options) {
      return this.render(jstDropdown, {
        idAttribute: id,
        items: data,
        uniqueId: _.random(0, 10000),
        options: options || {},
        templates: {
          groupedItem: jstGroupedDropdownItem,
          item: jstDropdownItem
        }
      });
    },

    text_button: function(text, link, options){
      var textHtml = this.content_tag('span', {
        'class': 'bd',
        'html': text
      });

      var iconHtml = '';

      if (options['icon']){
        iconHtml = this.content_tag('span', {
          'class': 'img space-right',
          'html': options['icon']
        });
      }

      options['class'] = '{0} button-new image-block state-text'.format(options['class'] || '');
      options['raw'] = true;

      var content = (iconHtml.length > 0 ? iconHtml : '') + textHtml;

      return this.link_to(link, content, options);
    },

    buttondDropdownToggle: function(options) {
      options['class'] = 'button-dropdown-toggle';

      return this.button('&#9662;', '', options);
    },

    selectedOption: function(currentId, selectedId) {
      return currentId === selectedId ? 'selected="selected"' : '';
    },

    checkedCheckbox: function(checked) {
      return checked ? 'checked="checked"' : '';
    },

    format_calculation: function(value, unit) {
      return podioUtils.formatNumber(value);
    },

    isPresent: function(value) {
      return typeof(value) != 'undefined' && value !== null && value !== '';
    },

    createdViaLinkFor: function(createdVia) {
      if (createdVia.display) {
        if (createdVia.url && createdVia.url !== '') {
          return this.link_to(createdVia.url, createdVia.name, {'class' : 'created-via-link'});
        } else {
          return _.escape(createdVia.name);
        }
      } else {
        return '';
      }
    },

    createdViaIconFor: function(createdVia) {
      if (createdVia.display) {
        var iconType = '';
        switch(createdVia.id) {
          // Mobile clients
          case 2: // iOS
          case 1185: // iOS
          case 16: // Android
            iconType = 'icon-16-mobile';
            break;
          // Mail
          case 31: // Mail
            iconType = 'icon-mail';
            break;
          // Other API integrations
          default:
            iconType = 'icon-16-black-lightning';
            break;
        }
        var icon = this.content_tag('span', {
          'class': 'tooltip sprite-icon created-via-icon '+iconType,
          'title': t('via {0} #comments').format(createdVia.name),
          'data-tooltip-gravity': 's'
        });
        if (createdVia.url && createdVia.url !== '') {
          return '<a href="' + createdVia.url + '">' + icon + '</a>';
        } else {
          return icon;
        }
      }
      return '';
    },

    referenceIconFor: function(obj) {
      var ref;

      if(obj instanceof Backbone.Model) {
        ref = obj.get('ref') ? obj.get('ref') : obj.get('reference');
      } else if (obj) {
        ref = obj.ref ? obj.ref : obj.reference;
      }

      if (ref) {
        return this.content_tag('span', {'class' : this.referenceIconClassFor(ref)});
      }
      return;

    },

    referenceIconClassFor: function(ref) {
      var isModel = ref instanceof Backbone.Model;
      var type = isModel ? ref.get('type') : ref.type;
      var classes = 'referential-ref-icon';

      var icon_id = null;
      switch(type) {
        case 'item':
          icon_id = isModel ? ref.get('data').app.icon_id : ref.data.app.icon_id;
          break;
        case 'app':
          icon_id = isModel ? ref.get('data').icon_id : ref.data.icon_id;
          break;
        case 'application':
          icon_id = isModel ? ref.get('icon_id') : ref.icon_id;
          break;
        default:
          icon_id = '';
          break;
      }

      return classes + ' ' + this.refIconClassByType(type, icon_id);
    },

    refIconClassByType: function(type, icon_id) {
      var classList = [];

      switch(type) {
        case 'space':
          classList.push('icon-16');
          classList.push('icon-space');
          break;
        case 'status':
          classList.push('icon-16');
          classList.push('icon-status');
          break;
        case 'item':
        case 'app':
        case 'application':
          classList.push('app-icon-16');
          classList.push('icon-'+icon_id);
          break;
        case 'task':
          classList.push('icon-16');
          classList.push('icon-16-task');
          break;
        case 'organization':
          classList.push('icon-16');
          classList.push('icon-org');
          break;
        case 'share':
        case 'app_store_share':
          classList.push('icon-16');
          classList.push('icon-16-grey-share');
          break;
        case 'conversation':
          classList.push('icon-16');
          classList.push('icon-message');
          break;
        case 'action':
          classList.push('icon-16');
          classList.push('icon-16-action');
          break;
        case 'file':
        case 'file_attachment':
          classList.push('icon-16');
          classList.push('icon-16-two-stacked-papers');
          break;
        case 'profile':
          classList.push('icon-16');
          classList.push('icon-user');
          break;
      }

      return classList.join(' ');
    },

    // file = { link (required), title (required) }
    // reference = { type (required), id (required), title (optional), link (optional), icon (optional) }
    startLinkToLightboxImage: function(file, reference, lightboxId) {
      var lightbox = 'lightbox';
      if (reference) {
        lightbox = 'lightbox-{0}-{1}'.format(reference.type, reference.id);
      } else if (lightboxId) {
        lightbox = 'lightbox-{0}'.format(lightboxId);
      }

      var html = '<a' +
        ' href="' + file.link +'"' +
        ' rel="' + lightbox + '"' +
        ' data-thumb-url="' + this.image_url_for(file.link, 'lightbox') + '"' +
        ' title="' + _.escape(file.title) + '"';
      if (reference.title) {
        html += ' data-context_title="' + _.escape(reference.title) + '"';
      }
      if (reference.link) {
        html += ' data-context_href="' + reference.link + '"';
      }
      if (reference.icon) {
        html += ' data-context_icon="' + reference.icon + '"';
      }
      html += ">";
      return html;
    },

    presenceDot: function(presenceState) {
      if(presenceState) {
        return this.content_tag("div", {
          html: presenceState.statusText,
          "class": "presence-state-large tooltip "+ presenceState.status,
          title: presenceState.status_text
        });
      } else {
        return this.content_tag("div", {
          "class": "presence-state-large offline"
        });
      }
    }

  };

  registerHelpers(BasicHelpers);

  return exports;

});

